// extracted by mini-css-extract-plugin
export default {"tabs":"AboveMainContent__tabs--3Ht","tab":"AboveMainContent__tab--2Tw","activeTab":"AboveMainContent__activeTab--1Wd"};